var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"tile",style:([
      { top: this.top, left: this.left },
      _vm.isFlipped
        ? { 'background-color': _vm.color }
        : { 'background-color': 'lightgrey' } ]),on:{"click":function($event){return _vm.flip()}}})])}
var staticRenderFns = []

export { render, staticRenderFns }